import React from 'react';
import * as LuIcons from 'react-icons/lu';
const { LuChrome } = LuIcons;
import SafeIcon from '../common/SafeIcon';

export default function ExtensionPromo() {
  return (
    <section className="py-12 bg-white border-y border-gray-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 shadow-xl shadow-blue-900/10">
          <div className="text-white max-w-xl">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">Save Money Automatically</h2>
            <p className="text-blue-100 text-lg">
              Install the Cheapo AI browser extension and compare prices while shopping natively on Amazon, Walmart, and 10,000+ other stores.
            </p>
          </div>
          <div className="shrink-0">
            <button className="bg-white text-gray-900 hover:bg-gray-50 px-8 py-4 rounded-full font-bold shadow-lg flex items-center gap-3 transition-transform hover:scale-105">
              <SafeIcon icon={LuChrome} className="text-xl text-blue-600" />
              Add to Chrome (Soon)
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}